import styles from './user.module.css';

export const customHeading = (title: string) => {
  return (
    <div className={styles.title}>{title}</div>
  )
}
